<template>
  <hr class="horizontal" style="margin: 8px 0" />
  <div class="d-flex-column justify-start align-start gap-18">
    <HoursPicker />
    <PlatformSelector />
    <hr class="horizontal" />
    <!-- <DeliveryOption /> -->
    <ExtraOptionPicker />
    <AddOnPicker />
  </div>
</template>

<script setup>
import HoursPicker from "../fc-25/pickers/HoursPicker.vue";
import PlatformSelector from "../fc-25/pickers/PlatformSelector.vue";
import ExtraOptionPicker from "../fc-25/pickers/ExtraOptionPicker.vue";
import AddOnPicker from "../fc-25/pickers/AddOnPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const deliveryOption = gameStore.getGamePack?.pack_options?.find(
  (op) => op.slug === "delivery_option"
);

const priorityOption = gameStore.getGamePack?.pack_options?.find(
  (op) => op.const_title === "standard"
);
const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setPlatform({
    platform: 1,
  });

  if (priorityOption) {
    checkoutStore.setPackOptions({
      options: [priorityOption.id],
    });
  }
  checkoutStore.setDetails({
    elearningTitle: "Coaching",
    numberOfHours: 1,
  });

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
